import { render, staticRenderFns } from "./PtorageSituation.vue?vue&type=template&id=737c7522&scoped=true&"
import script from "./PtorageSituation.vue?vue&type=script&lang=js&"
export * from "./PtorageSituation.vue?vue&type=script&lang=js&"
import style0 from "./PtorageSituation.vue?vue&type=style&index=0&id=737c7522&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "737c7522",
  null
  
)

export default component.exports